var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showSlides)?_c('Hero',{on:{"switchScreen":_vm.getCurrent}}):_c('div',{attrs:{"fluid":""}},[[_c('Slides',{attrs:{"current":_vm.current},on:{"switchScreen":function($event){_vm.showSlides = false}}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }